import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import portalOne from "./assets/portal/portal_1.png";
import portalTwo from "./assets/portal/portal_2.png";
import portalThree from "./assets/portal/portal_3.png";
import portalFour from "./assets/portal/portal_4.png";
import portalFive from "./assets/portal/portal_5.png";
import portalSix from "./assets/portal/portal_6.png";
import portalSeven from "./assets/portal/portal_7.png";
import portalTen from "./assets/portal/portal_10.png";

import portalEight from "./assets/e-commerce/e-commerce_9.png";

import webDevSeven from "./assets/web-dev/web_dev_7.png";
import portalNine from "./assets/portal/portal_8.png";

import bannerImage from "./assets/e-commerce/e-commerce_6.jpg";
import { Divider } from "@mui/material";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";
import { useLocation } from "react-router-dom";

const ApplicationPortal = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [
    portalSeven,
    portalThree,
    portalFour,
    portalFive,
    portalSix,
    portalTwo,
  ];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${portalOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              Application Portal
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              Application Portal
            </Typography>
            <Typography variant="body1" paragraph>
              An application portal is an essential component of any mobile app
              ecosystem, whether it's built for Android, iOS, or both. It acts
              as the control center where administrators or business owners can
              view and manage critical analytics related to app performance and
              user behavior. From tracking the number of downloads to
              identifying the most frequently used features, the portal provides
              real-time insights that help guide product decisions and
              improvements. It gives a centralized overview of how users
              interact with the app, enabling you to monitor engagement,
              retention, and usage trends effectively.
            </Typography>

            <Typography variant="body1" paragraph>
              Beyond just analytics, a robust application portal offers tools
              for operational monitoring as well. It can display metrics like
              how many users are currently online, how often the app is being
              opened, and even server configuration details for backend
              performance management. Whether you want to track session
              durations, view error logs, manage user access, or control in-app
              features remotely, the portal is the place to do it. In short, an
              application portal bridges the gap between your mobile app and the
              decision-making process, ensuring your business runs smarter and
              more efficiently.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Why us?
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              When it comes to building powerful and intuitive application
              portals, we bring unmatched experience and expertise to the table.
              Having worked extensively on mobile app development across various
              industries, we understand the vital role a portal plays in
              ensuring seamless management, monitoring, and scaling of any
              application. Our team has successfully delivered both Android and
              iOS apps along with their corresponding portals, enabling clients
              to access real-time analytics, manage features, monitor user
              activity, and make data-driven decisions. With a strong track
              record in building secure, scalable, and user-friendly portals, we
              are your ideal partner to bring the complete app ecosystem to life
              — from front-end experience to backend intelligence.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={portalNine}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Years of experience
            </Typography>
            <Typography variant="body1">
              With a solid foundation built over years of hands-on development,
              we bring a wealth of experience to every project we undertake. Our
              journey in E-commerce and application development has equipped us
              with a deep understanding of industry challenges and evolving
              customer needs. We’ve successfully delivered robust, scalable, and
              performance-driven solutions across various sectors — from
              startups to enterprise-level businesses. Each developer on our
              team brings specialized expertise and a commitment to quality,
              ensuring every website or app we build is secure, efficient, and
              aligned with your business goals. Whether it’s creating custom
              features, optimizing performance, or integrating third-party
              services, we have the practical knowledge to deliver outstanding
              results. Our experience is not just in writing code — it’s in
              building long-lasting, value-driven digital experiences.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Latest tools and technologies
            </Typography>
            <Typography variant="body1">
              Whether it is Angular, .NET, Python, PHP, Laravel, React, or
              Node.js – we are equipped with the latest tools and technologies
              to deliver cutting-edge products that stand out in today’s
              competitive market. Our team continuously stays updated with
              emerging trends, best practices, and innovations to ensure your
              project benefits from the most effective solutions available.
              Beyond just development, we focus on creating optimized, scalable,
              and user-friendly platforms that enhance your business’s online
              visibility and attract high-quality, engaged visitors. From
              seamless performance to responsive design, we work diligently to
              help your E-commerce website not only launch successfully but also
              grow and thrive in the long run.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={portalTen}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={portalEight}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Affordable Application Portal development
            </Typography>
            <Typography variant="body1">
              Building a high-quality application portal doesn’t have to come
              with an overwhelming price tag. At our company, we specialize in
              developing robust, user-friendly application portals that are not
              only feature-rich but also cost-effective. Whether you're
              launching a new mobile app or managing an existing one, our
              portals offer real-time insights into app usage, user behavior,
              server performance, and analytics — all tailored to your business
              needs and budget. We believe that powerful admin tools should be
              accessible to businesses of all sizes. That’s why our development
              process focuses on delivering maximum functionality at a
              reasonable cost. With flexible pricing models and scalable
              solutions, we ensure your portal grows with your application while
              keeping operational costs under control. Partner with us to get an
              efficient, affordable solution without compromising on quality or
              performance.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Extended Support
            </Typography>
            <Typography variant="body1">
              Our commitment to you doesn’t end after deployment — we offer
              ongoing extended support to ensure your application and its portal
              continue to run smoothly and efficiently. From resolving bugs and
              performance issues to implementing feature enhancements based on
              user feedback, our team remains actively involved post-launch. We
              understand that technology evolves rapidly, and we’re here to help
              you adapt and grow without disruptions. With direct access to our
              expert developers, you can get timely answers to technical
              questions, make real-time adjustments, and receive updates that
              align with your business goals. Whether it’s scaling your
              infrastructure, optimizing analytics dashboards, or securing your
              system, our extended support ensures you're never left navigating
              challenges alone. We're not just building software — we’re
              building long-term partnerships.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={webDevSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default ApplicationPortal;
